import * as React from "react";
const SvgFiRrLocationExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-location-exclamation_svg__a)">
      <path
        fill="#062147"
        d="M19.777 3.222A10.93 10.93 0 0 0 12 0C9.063 0 6.3 1.145 4.222 3.222-.067 7.511-.067 14.489 4.25 18.806l3.942 3.642A5.42 5.42 0 0 0 12 24.001a5.4 5.4 0 0 0 3.786-1.533l3.991-3.688c4.289-4.289 4.289-11.268 0-15.557zm-1.386 14.115-3.983 3.681c-1.295 1.268-3.5 1.287-4.838-.02l-3.935-3.634c-3.509-3.51-3.509-9.219 0-12.729A8.95 8.95 0 0 1 12 1.999c2.403 0 4.663.937 6.363 2.636 3.509 3.51 3.509 9.219.028 12.701zM10.999 11.5V6a1 1 0 1 1 2 0v5.5a1 1 0 1 1-2 0m2.5 4a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-location-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLocationExclamation;
